// @ts-nocheck
import UaFlag from '../assets/images/flags/ua.svg';
import GbFlag from '../assets/images/flags/gb.svg';

const languages = {
  en: {
    label: 'English',
    flag: GbFlag,
  },
  ua: {
    label: 'Українська',
    flag: UaFlag,
  },
};

export default languages;
